import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CalendarIcon, MapPinIcon } from 'lucide-react';
import { VideoCard } from './VideoCard';
import { site } from '../data/site';
const fade = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function Hero() {
  return <section id="top" className="relative isolate overflow-hidden bg-forest pt-28 sm:pt-32 lg:pt-40" data-id="element-61" data-mp="4mi3tby6fqf0">
      <img src={site.heroBgUrl} alt="" aria-hidden="true" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-30" data-id="element-62" data-mp="1286262e70it6" />
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-forest/80" data-id="element-63" data-mp="sarsqmqosuad" />

      <div className="mx-auto grid max-w-shell items-center gap-12 px-5 pb-20 sm:px-8 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:pb-28" data-id="element-64" data-mp="ncztf7npq5w5">
        <motion.div initial="hidden" animate="show" transition={{
        staggerChildren: 0.09,
        delayChildren: 0.05
      }} data-id="element-65" data-mp="3d33f4zea6vla">
          <motion.p variants={fade} className="text-xs uppercase tracking-widest2 text-cream-muted" data-id="element-66" data-mp="3j7zfnjujfuh7">
            Count Club <span className="mx-2 text-cream/30" data-id="element-67" data-mp="3o6u87dib4xei">|</span> Austin
          </motion.p>

          <motion.h1 variants={fade} className="mt-5 max-w-xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl" data-id="element-68" data-mp="399jnrenosh6n">
            Community event for ecommerce CFOs
          </motion.h1>

          <motion.p variants={fade} className="mt-6 max-w-md text-lg text-cream-dim" data-id="element-69" data-mp="30g6mnpfgy99h">
            Connect, learn, and enjoy Texas BBQ with 30 of the best finance leaders in ecommerce
          </motion.p>

          <motion.div variants={fade} className="mt-8 flex flex-wrap gap-3" data-id="element-70" data-mp="2qi0o9hsvfl9d">
            <span className="inline-flex items-center gap-2 rounded-full border border-cream/25 px-4 py-2 text-sm text-cream" data-id="element-71" data-mp="2vj7sx7zpw4bt">
              <CalendarIcon size={16} className="text-cream/60" data-id="element-72" data-mp="2lkqx9xpu31jf" />
              {site.date}
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-cream/25 px-4 py-2 text-sm text-cream" data-id="element-73" data-mp="s1rsopcm88ut">
              <MapPinIcon size={16} className="text-cream/60" data-id="element-74" data-mp="na9yql90f8jc" />
              {site.location}
            </span>
          </motion.div>

          <motion.div variants={fade} className="mt-10 flex flex-wrap items-center gap-5" data-id="element-75" data-mp="ia5jeyju8jup">
            <a href="#register" className="group inline-flex items-center gap-2 rounded-full bg-cream px-7 py-3.5 text-sm font-semibold text-forest transition hover:bg-white" data-id="element-76" data-mp="1b0njdqp9m53w">
              Get your ticket

              <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-77" data-mp="112g89ohnqh9t" />
            </a>
            <p className="text-sm text-cream-muted" data-id="element-78" data-mp="x1w7maxvkvix">
              30 tickets · {site.price} per person
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25,
        ease: 'easeOut'
      }} data-id="element-79" data-mp="3hrd8esqpz5yu">
          <VideoCard data-id="element-80" data-mp="1x785vq9lpvv6" />
        </motion.div>
      </div>
    </section>;
}